import { Component, ContentChildren, EventEmitter, Input, Output, QueryList, ViewChild } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormFunctions } from 'src/app/functions';

@Component({
    selector: 'modal-search-filter-item',
    styleUrls: ['./modal-search-filter-item.component.scss'],
    templateUrl: 'modal-search-filter-item.component.html'
})
export class ModalSearchFilterItemComponent {
    @ContentChildren(NgModel, { descendants: true }) public models: QueryList<NgModel>;
    @ViewChild(NgForm) public form: NgForm;

    @Input() processing: boolean = false;
    @Input() error: boolean = false;
    @Input() errorMessage: string = "";
    @Input() modalMode: boolean = true;

    @Input() title: string = "";

    @Output() save: EventEmitter<NgForm> = new EventEmitter();
    @Output() close: EventEmitter<any> = new EventEmitter();

    constructor(private formFunctions: FormFunctions) {
        let me = this;
    }

    public ngAfterViewInit(): void {
        let ngContentModels = this.models.toArray();
        ngContentModels.forEach((model) => {
            this.form.addControl(model);
        });
    }

    Save(form, e) {
        let me = this;
        // console.log('Save', form);
        if (me.formFunctions.isFormValid(form, e)) {
            this.save.emit(form);
        }
    }

    Close() {
        this.close.emit(null);
    }
}